import { resolvePointAnchor } from "./shared";
export function pixelToChartPoint(clientX, clientY, containerRect, scales) {
    const localX = clientX - containerRect.left;
    const localY = clientY - containerRect.top;
    return {
        x: scales.xScaleInvert(localX).getTime(),
        y: scales.yScaleInvert(localY),
    };
}
export function chartPointToPixel(point, scales) {
    const anchor = resolvePointAnchor(point);
    // Return NaN point if no valid data-space anchor exists
    if (anchor.xIndexFloat === undefined && (!anchor.timeMsHint || !Number.isFinite(anchor.timeMsHint))) {
        return { x: NaN, y: NaN, xIndexFloat: undefined, yPrice: undefined }; // Cannot project — no valid data-space anchor
    }
    const x = anchor.xIndexFloat !== undefined && scales.xScaleByIndex
        ? scales.xScaleByIndex(anchor.xIndexFloat)
        : (anchor.timeMsHint ? scales.xScale(new Date(anchor.timeMsHint)) : NaN);
    if (!Number.isFinite(x)) {
        return { x: NaN, y: NaN, xIndexFloat: undefined, yPrice: undefined };
    }
    const y = anchor.yPrice !== undefined ? scales.yScale(anchor.yPrice) : NaN;
    if (!Number.isFinite(y)) {
        return { x: NaN, y: NaN, xIndexFloat: undefined, yPrice: undefined };
    }
    return {
        x,
        y,
        xIndexFloat: anchor.xIndexFloat ?? undefined,
        yPrice: anchor.yPrice,
    };
}
